import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    disclaimer: {
      paddingTop: 32,
      fontSize: 12,
      color: theme.oysterTheme.shark,
      '& a': {
        fontSize: 12,
        color: ({ secondaryColor }) => secondaryColor,
      },
    },
    submitButton: {
      marginTop: 20,
      backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
      borderColor: ({ primaryColor }) => `${primaryColor} !important`,
    },
    progress: {
      color: '#FFF',
    },
  }),
);

export default useStyles;
